import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, description, dark = false, align = "center" }) => (
  <Reveal
    className={`mb-14 max-w-3xl ${align === "center" ? "mx-auto text-center" : "text-left"}`}
  >
    {eyebrow && (
      <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-gold">
        {eyebrow}
      </p>
    )}
    <h2
      className={`font-serif text-3xl font-bold leading-tight tracking-tight sm:text-4xl lg:text-[2.75rem] ${
        dark ? "text-white" : "text-navy-900"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-300" : "text-slate-600"}`}>
        {description}
      </p>
    )}
    <span
      className={`mt-6 block h-px w-16 bg-gold ${align === "center" ? "mx-auto" : ""}`}
      aria-hidden="true"
    />
  </Reveal>
);
